import { type UseQueryResult, useQuery } from 'react-query';
import {
  PerformanceRuleApprovalService,
  PerformanceRuleService,
} from '../../services/wealthlane-award-services';

const useGetApproverPerformanceRuleAvailableStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const ApproverPerformanceRuleAvailableStatus = useQuery(
    ['getApproverPerformanceRuleAvailableStatus'],
    async () => {
      return await handleRequest(
        PerformanceRuleApprovalService.getApiAwardApiAppPerformanceRuleApprovalRuleAvailableStatusList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return ApproverPerformanceRuleAvailableStatus;
};

export default useGetApproverPerformanceRuleAvailableStatus;
